import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  exportRentals,
  exportLocationRentalsRoutes,
  exportSystemRentalsRoutes,
} from '../../../api/rentals';
import { IUseRental } from '../../../ts/interface/rental.interface';

const useExportRentals = (
  parameters?: IUseRental,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['rentals', parameters?.systemId],
    queryFn: () => exportRentals(parameters?.queryParameters),
    ...options,
  });
};

interface IUseExportRentalsRoutes extends IUseRental {
  locationUUID: string;
}

export const useExportRentalsRoutes = (
  parameters?: IUseExportRentalsRoutes,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['rentalsRoutes', parameters?.systemId],
    queryFn: () =>
      exportLocationRentalsRoutes(parameters?.locationUUID, parameters?.queryParameters),
    ...options,
  });
};

export const useExportSystemRentalsRoutes = (
  parameters?: IUseRental,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['rentals', parameters?.systemId],
    queryFn: () => exportSystemRentalsRoutes(parameters?.queryParameters),
    ...options,
  });
};

export default useExportRentals;
